import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

type Entity = models.PaqueteDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnas: Column[] = [
    { title: "Cantidad", cell: x => ({ data: x.Cantidad }) },
    { title: "Peso (kg)", cell: x => ({ data: x.Peso }) },
    { title: "Peso volumétrico", cell: x => ({ data: x.PesoVolumetrico }) },

    { title: "Volumen (M3)", cell: x => ({ data: ( (x.Alto*x.Largo*x.Ancho) /1000000) }) },
    
    { title: "Largo (cm)", cell: x => ({ data: x.Largo }) },
    { title: "Alto (cm)", cell: x => ({ data: x.Alto }) },
    { title: "Ancho (cm)", cell: x => ({ data: x.Ancho }) },
    { title: "Valor declarado", cell: x => ({ data: x.ValorDeclarado, view: kea.formatCurrency }) },
    { title: "Flete", cell: x => ({ data: x.Importes.Flete, view: kea.formatCurrency }) },
    { title: "Todos los importes", cell: x => ({ data: x.Importes }) },
    { title: "Descripción", cell: x => ({ data: x.NombreDescripcionPaquete }) },
    { title: "Contenido", cell: x => ({ data: x.NombreContenidoPaquete }) },
    { title: "Obsrvaciones", cell: x => ({ data: x.Observaciones }) },
];



export interface Props {
    value: Entity[];
}

/**
* Listado de paquetes
*/
export class Paquetes extends React.PureComponent<Props> {

    render() {
        const cols = columnas;
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h4>
                            <span>Paquetes</span>
                        </h4>
                    </div>
                </div>

                <kea.Grid2 items={this.props.value} columnas={cols} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/guias/edit/listas/paquetes/index.tsx